<!-- Нейтральный маркер стоянки: статичный квадрат без ассоциации с медиаплеером. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="6"
      y="6"
      width="12"
      height="12"
      rx="2"
      :fill="stroke"
      :stroke="stroke"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  name: "StatusStoppedIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
